import React from "react";
import { Card, CardBody, CardTitle, Spinner } from "reactstrap";
import { ConnectComponentsProvider, ConnectPayoutsList } from "@stripe/react-connect-js";
import { useStripeConnect } from "./StripeConnectContext";

/**
 * Full payout history, powered by Stripe's embedded payout list. Replaces
 * the old mock Firebase payments table — Porcher doesn't keep its own copy
 * of payout data.
 */
const StripePayoutHistory = () => {
  const { status, connectInstance } = useStripeConnect();

  if (!status?.onboardingComplete) return null;

  return (
    <Card className="mb-4">
      <CardBody>
        <CardTitle tag="h5" className="mb-3">Payout History</CardTitle>

        {connectInstance ? (
          <ConnectComponentsProvider connectInstance={connectInstance}>
            <ConnectPayoutsList />
          </ConnectComponentsProvider>
        ) : (
          <div className="text-center py-4"><Spinner color="primary" /></div>
        )}
      </CardBody>
    </Card>
  );
};

export default StripePayoutHistory;
